import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  headingsPlugin,
  imagePlugin,
  InsertImage,
  InsertTable,
  linkPlugin,
  listsPlugin,
  ListsToggle,
  markdownShortcutPlugin,
  MDXEditor,
  MDXEditorMethods,
  MDXEditorProps,
  quotePlugin,
  Separator,
  tablePlugin,
  thematicBreakPlugin,
  toolbarPlugin,
} from "@mdxeditor/editor";
import "@mdxeditor/editor/style.css";
import { forwardRef } from "react";
import dealService from "services/deal.service";
import styles from "./MarkdownInput.styles.module.scss";
import { config } from "config";
import { captureException } from "@sentry/react";

interface MarkdownInputProps
  extends Omit<MDXEditorProps, "markdown" | "plugins"> {
  value: string;
}

export const defaultMarkdownInputPlugins = [
  headingsPlugin(),
  listsPlugin(),
  quotePlugin(),
  tablePlugin(),
  thematicBreakPlugin(),
  markdownShortcutPlugin(),
  linkPlugin(),
];

export const MarkdownInput = forwardRef<MDXEditorMethods, MarkdownInputProps>(
  ({ value, readOnly, ...props }, ref) => {
    return (
      <MDXEditor
        {...props}
        readOnly={readOnly}
        className={styles.Container}
        plugins={[
          ...defaultMarkdownInputPlugins,
          imagePlugin({
            imageUploadHandler: async (image: File) => {
              const formData = new FormData();

              formData.append("file", image, image.name);

              const { imageUrl } = await dealService.uploadDealImage(formData);

              return imageUrl;
            },
          }),
          toolbarPlugin({
            toolbarContents: () => (
              <>
                <ListsToggle />
                <Separator />
                <BlockTypeSelect />
                <BoldItalicUnderlineToggles />
                <Separator />
                <InsertTable />
                <InsertImage />
              </>
            ),
          }),
        ]}
        onError={(error) => {
          if (["dev", "local"].includes(config.env)) {
            console.error(error);
            return;
          }

          captureException(error);
        }}
        markdown={value}
        ref={ref}
      />
    );
  }
);
